import React from 'react';
import { usePortfolio } from '../hooks/usePortfolio';
import { CursosGridItem } from './CursosGridItem';
import { Button } from 'react-bootstrap';
import Loader from 'react-ts-loaders';

function hideDataLoaded() {
    const slideElements = document.querySelectorAll(
            "#idhome_slider_area, #idslide_controls, #idslide_screens, #mobile_slider_area, #catalogo_servicios, #section1, #section2, #section3, #hw_search"
        )
    for (const slideElement of slideElements) {
        slideElement.classList.add('hide');
    };
};

function refreshPage() {
    window.location.reload(true);
};

export const CursosGrid = ({ category }) => {

    const { data:cursos, loading } = usePortfolio( category );

    return (
        <>
            <div className='resuldatos_titulo'>
                <h3>Resultados de busqueda:&nbsp;<span>{ category }</span></h3>
            </div>

            <div className='resultados_busqueda'>            
                { 
                    loading && 
                    <Loader 
                        type="spinner"
                        color="#3b67e2"
                        altColor="#467ba6"
                        size={64}
                        message="Buscando resultados"
                        className="portfolio_loader"
                    />
                }
                    
                {
                    hideDataLoaded()
                }

                {
                    cursos.map( curso => (
                        <CursosGridItem 
                            key={ curso.id }
                            { ...curso }
                        />
                    ))
                }

            </div>

            <div>
                <Button
                    onClick={refreshPage}
                    id='showSlideElements'
                    variant="primary"
                    >Regresar
                </Button>
            </div>
            
        </>

    )
}
